// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2963":"64940a85","3359":"5eed07a5"}[chunkId] + ".chunk.css";
};